import React from 'react';

/**
 * Loading fallback component displayed while lazy-loaded routes are loading
 * Used with React.Suspense for code splitting
 */
export const LoadingFallback: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#060A16]">
      <div className="flex flex-col items-center gap-6">
        <div className="relative w-16 h-16">
          <div className="absolute inset-0 rounded-full border-4 border-white/10" />
          <div className="absolute inset-0 rounded-full border-4 border-transparent border-t-[#5C7CFA] animate-spin" />
          <div className="absolute inset-4 rounded-full bg-[#5C7CFA]/20 flex items-center justify-center">
            <span className="text-xl leading-none">⚡</span>
          </div>
        </div>
        <p className="text-white/60 text-sm font-medium tracking-wide">Loading…</p>
      </div>
    </div>
  );
};
